import { render, staticRenderFns } from "./fmRouteCenter.vue?vue&type=template&id=036aeda3&scoped=true&"
import script from "./fmRouteCenter.vue?vue&type=script&lang=js&"
export * from "./fmRouteCenter.vue?vue&type=script&lang=js&"
import style0 from "./fmRouteCenter.vue?vue&type=style&index=0&id=036aeda3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036aeda3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036aeda3')) {
      api.createRecord('036aeda3', component.options)
    } else {
      api.reload('036aeda3', component.options)
    }
    module.hot.accept("./fmRouteCenter.vue?vue&type=template&id=036aeda3&scoped=true&", function () {
      api.rerender('036aeda3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/fmRouteCenter.vue"
export default component.exports